/**
 * ag-cart-keep-open.js · A Granel Madrid
 *
 * Mantiene el cajón del carrito abierto al eliminar una línea.
 *
 * Por qué hace falta: al pulsar la papelera, el componente del carrito quita la
 * fila del DOM durante el propio despacho del clic. Cuando el evento llega al
 * listener de "clic fuera" de dialog.js, `dialog.contains(event.target)` ya es
 * false (el botón dejó de existir), así que lo toma por un clic en el backdrop
 * y llama a closeDialog().
 *
 * Solución: envolver closeDialog en la instancia del cajón e ignorar el cierre
 * durante una ventana muy corta después de pulsar eliminar. Si la línea
 * eliminada era la última, no se pone guarda: el cajón se cierra como antes.
 */
(function () {
  if (window.__agCartKeepOpen) return;
  window.__agCartKeepOpen = true;

  var GUARD_MS = 1200;
  var guardUntil = 0;

  function patch(comp) {
    if (comp.__agPatched) return;
    comp.__agPatched = true;

    // 1) Cierre por closeDialog() (el "clic fuera" de dialog.js pasa por aquí).
    var original = comp.closeDialog;
    if (typeof original === 'function') {
      comp.closeDialog = function () {
        if (Date.now() < guardUntil) return; // cierre colateral del borrado
        return original.apply(this, arguments);
      };
    }

    // 2) Cierre por pérdida del atributo `open` (re-render del carrito).
    var dialog = comp.querySelector('dialog');
    if (!dialog) return;
    new MutationObserver(function () {
      if (Date.now() >= guardUntil) return;
      if (dialog.open) return;
      try {
        dialog.showModal();
      } catch (e) {}
    }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
  }

  // pointerdown, no click: Horizon detiene la propagación del click de la
  // papelera, así que un listener de click nunca llega a ejecutarse.
  function onPointerDown(e) {
    {
      var target = e.target;
      if (!target || !target.closest) return;

      // La cruz debe cerrar siempre, aunque coincida con la ventana de guarda.
      if (target.closest('.cart-drawer__close-button')) {
        guardUntil = 0;
        return;
      }

      var btn = target.closest('.cart-items__remove');
      if (!btn) return;

      var comp = btn.closest('cart-drawer-component');
      if (!comp) return;

      var lines = comp.querySelectorAll('.cart-items__remove').length;

      // Última línea: dejar que el cajón se cierre solo.
      if (lines <= 1) return;

      patch(comp);
      guardUntil = Date.now() + GUARD_MS;
    }
  }

  document.addEventListener('pointerdown', onPointerDown, true);
  document.addEventListener('mousedown', onPointerDown, true);

  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key === 'Escape') guardUntil = 0;
    },
    true
  );
})();
